import React, {useEffect, useState} from "react";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ConfirmDialog from "../../general/ConfirmDialog";
import DHDialog from "../../general/DHDialog";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHButtonSave from "../../general/DHButtonSave";
import DHButtonIconDelete from "../../general/DHButtonIconDelete";

export default function WerbungenDialog({eventOperatorId, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    let [ werbungen, setWerbungen] = useState([]);

    let [ selectedDeleteId, setSelectedDeleteId] = useState(undefined);
    let [ imageLink, setImageLink] = useState("");
    let [ url, setUrl] = useState("");

    useEffect(() => {
        ladeWerbungen();
    }, [eventOperatorId]);


    const ladeWerbungen = () => {
        if( eventOperatorId === null || eventOperatorId === undefined) {
            return;
        }
        let url = ConfigUtil.getConfig().resourceUrls.werbung + "/" + eventOperatorId;
        FetchUtil.fetchGet(url,
            json => {
                setWerbungen(json)
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden" + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden" + error.message);
        });
    }

    const save = () => {
        let data = {eventOperatorId: eventOperatorId, imageUrl: imageLink, url: url};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.werbung + "/save",
            data,
            json => {
                ladeWerbungen();
                setImageLink("");
                setUrl("");
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const deleteWerbung = (id) => {
        let url = ConfigUtil.getConfig().resourceUrls.werbung + "/delete/" + eventOperatorId + "/" + id;
        FetchUtil.fetchDelete(url,
            {},
            json => {
                setSelectedDeleteId(undefined);
                ladeWerbungen();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const getRows = () => {
        let rows = [];
        for (const werbung of werbungen) {
            rows.push(<div key={"key_werbung_" + werbung.id} style={{marginBottom:10}}>
                <div>
                    <DHButtonIconDelete onClick={() => setSelectedDeleteId(werbung.id)}/><br/>
                    ImageUrl: {werbung.imageUrl}<br/>
                    Ziel beim Klick: {werbung.url}<br/>
                </div>
                <div><img src={werbung.imageUrl} alt="Werbung" style={{width:310, height:50}}/>
                </div>
            </div>)
        }
        return rows;
    }

    return <DHDialog onClose={() => onClose()} title="Werbung" show={true} showCloseButton={true}
                     comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div>Im Live-View kann Werbung angezeigt werden. Du kannst hier beliebig viele Werbepartner einfügen.</div>
        <div style={{marginTop:10, fontWeight:"bold"}}>Wichtig! Aus Performancegründen kann es bis zu 10 Minuten dauern, bis deine eingepflegte Werbung an einem Game angezeigt wird.</div>
        <div style={{marginTop:10}}>Aufgrund von möglichen Virenangriffen haben wir uns aktuell für eine sichere Lösung entschieden.
            Bitte lade dein Bild mit der Werbung auf deinen eigenen Webspace, deiner Cloud oder ähnliches hoch und gebe hier nur den Link dahin an.</div>
        <div>Sofern du keine Möglichkeit hast deine Werbedatei abzulegen, sende uns diese bitte per Mail an darthelfer@nl-soft.com. Wir prüfen die Datei und legen diese bei uns ab.</div>
        <div>Bitte vergesse nicht, uns deinen Veranstalternamen in der Mail mitzuteilen.</div>
        <div style={{fontWeight:"bold"}}>Achtung!!! Das Werbebild wird in der Größe 310x80 Pixel angezeigt und muss genau dieser Größe entsprechen.</div>
        <div style={{marginTop:10}}>
            Das Ändern eines Links ist aktuell nicht vorgesehen. Sofern dies notwendig wird, bitte Link löschen und neu anlegen.
        </div>
        <div style={{marginTop:20, marginBottom:20}}>
            <DHTextFieldSmall value={imageLink} width="100%" showPlaceholder={false} label="URL zum Bild" onChange={(text) => setImageLink(text)}/>
            Beispiel: https://darthelfer.de/images/darthelfer.png
        </div>
        <div style={{marginTop:5}}>
            <DHTextFieldSmall id="id-werbung-url" label="URL - sobald auf das Bild geklickt wird" showPlaceholder={false}
                              value={url} width="100%" onChange={(text) => setUrl(text)}/>
            Beispiel: https://darthelfer.de
        </div>
        <div style={{marginTop:5}}>
            <DHButtonSave onClick={() => save()} label="Speichern" disabled={imageLink === ""}/>
        </div>
        <div style={{marginTop:20}}>
            {getRows()}
        </div>
        <ConfirmDialog visible={selectedDeleteId !== undefined}
                       callBackOnNein={() => setSelectedDeleteId(undefined)}
                       callBackOnJa={() => deleteWerbung(selectedDeleteId)}
                       header="Werbung löschen?"
                       textUnten="Möchtest du die Werbung wirklich löschen?"/>

    </>}/>
}
